import * as React from "react";
import { SVGProps } from "react";
const SvgRatingPositive = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#rating-positive_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0Zm0 2C8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14S23.732 2 16 2Zm7.718 17.087a1 1 0 0 1 .506 1.32 9.003 9.003 0 0 1-16.448 0 1 1 0 0 1 1.827-.814 7.002 7.002 0 0 0 12.794 0 1 1 0 0 1 1.32-.506h.001ZM10.5 10a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm11 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="rating-positive_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRatingPositive;
